import React, { useRef } from 'react';
//import { LeftCircleFilled, RightCircleFilled } from '@ant-design/icons';
import { Carousel } from "antd";
import { shuffle } from "lodash";

import Original from "@assets/images/Original.png";
import First from "@assets/images/First.png";
import Second from "@assets/images/Second.png";
import Third from "@assets/images/Third.png";
import Fourth from "@assets/images/Fourth.png";
import Fifth from "@assets/images/Fifth.png";
import Sixth from "@assets/images/Sixth.png";
import Seventh from "@assets/images/Seventh.png";
import Eighth from "@assets/images/Eighth.png";
import Nineth from "@assets/images/Nineth.png";
import Tenth from "@assets/images/Tenth.png";
import StartVideo from "../assets/video/StartVideo.mp4";

import "./imageSlider.scss";
import { useEffect, useState } from "react";

const ImageSlider = () => {
  

  const [addresses,setAddresses]= useState<any>();
  const [playCarousel, setPlayCarousel] = useState<boolean>(false);

  useEffect(()=>{
    console.log("ImageSlider.useEffect");
    const Addresses = [
      {
        id: 11,
        src: Original,
        alt: "Original",
      },
      {
        id: 1,
        src: First,
        alt: "First",
      },
      {
        id: 2,
        src: Second,
        alt: "Second",
      },
      {
        id: 3,
        src: Third,
        alt: "Third",
      },
      {
        id: 4,
        src: Fourth,
        alt: "Fourth",
      },
      {
        id: 5,
        src: Fifth,
        alt: "Fifth",
      },
      {
        id: 6,
        src: Sixth,
        alt: "Sixth",
      },
      {
        id: 7,
        src: Seventh,
        alt: "Seventh",
      },
      {
        id: 8,
        src: Eighth,
        alt: "Eighth",
      },
      {
        id: 9,
        src: Nineth,
        alt: "Nineth",
      },
      {
        id: 10,
        src: Tenth,
        alt: "Tenth",
      },
    ];
    setAddresses(shuffle(Addresses));
  }, [])

  const handleVideoEnd = () => {
    setPlayCarousel(true);
  }

  return (
    <div className="image__slider">
    <video className={`video ${playCarousel ? "hidden fadeOut" : "show"}`} autoPlay muted onEnded={handleVideoEnd}>
      <source src={StartVideo} type="video/mp4" />
    </video>
    <Carousel className={`${!playCarousel ? "hidden fadeOut" : "show fadeIn"}`} autoplay={true} effect="fade" pauseOnHover={false} autoplaySpeed={6000} >
      {addresses && (addresses).map((address:any, index:any) => {
        return (
          <img
          key={'img_'+ index}
            className="banner"
            src={`${address.src}`}
            alt={`Slide + ${index + 1}`}
          />
        );
      })}
    </Carousel>
    </div>
  );
};

export default ImageSlider;
